import { Box, Typography } from "@mui/material";
import { AMERICAS_FASTEST_PART1, AMERICAS_FASTEST_PART2 } from "../../../Constants/constants";
import { Theme } from "../../../Styles/GlobalTheme";
const PromosBanner = () => {
  return (
    <Box
      sx={{
        backgroundColor: Theme.palette.customcolor.menuitembackground,
        boxShadow: "inset 0 8px 10px -10px rgba(0, 0, 0, 0.15)",
        textAlign: "center",
        padding: "4px",
      }}>
      <Typography
        component="span"
        sx={{
          color: Theme.palette.customcolor.profileTypoGraphyColor,
          fontWeight: 500,
          fontSize: "20px",
        }}>
        {AMERICAS_FASTEST_PART1}{" "}
      </Typography>
      <Typography
        component="span"
        sx={{ color: Theme.palette.customcolor.green_100, fontWeight: 500, fontSize: "20px" }}>
        {AMERICAS_FASTEST_PART2}
      </Typography>
    </Box>
  );
};
export default PromosBanner;
